export default "__VITE_ASSET__Sw_WVACv__"